/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { MailboxImapCreateRequestImapSecurity } from './mailboxImapCreateRequestImapSecurity';
import type { MailboxImapCreateRequestSmtpSecurity } from './mailboxImapCreateRequestSmtpSecurity';

/**
 * Direct IMAP/SMTP connection.
 *
 * Per spec §6a, the V1 UI defers IMAP entry but the backend route ships
 * behind the existing ``/api/connected-accounts/mailboxes/imap`` surface.
 * ``imap_password`` and ``smtp_password`` are NEVER persisted in plaintext —
 * they are forwarded straight to Nylas in the same request.
 */
export interface MailboxImapCreateRequest {
  email_address: string;
  /**
     * @minLength 1
     * @maxLength 120
     */
  display_name: string;
  /**
     * @minLength 1
     * @maxLength 255
     */
  imap_host: string;
  /**
     * @minimum 1
     * @maximum 65535
     */
  imap_port: number;
  /**
     * @minLength 1
     * @maxLength 255
     */
  imap_username: string;
  /**
     * @minLength 1
     * @maxLength 255
     */
  imap_password: string;
  /**
     * @minLength 1
     * @maxLength 255
     */
  smtp_host: string;
  /**
     * @minimum 1
     * @maximum 65535
     */
  smtp_port: number;
  /**
     * @minLength 1
     * @maxLength 255
     */
  smtp_username: string;
  /**
     * @minLength 1
     * @maxLength 255
     */
  smtp_password: string;
  imap_security?: MailboxImapCreateRequestImapSecurity;
  smtp_security?: MailboxImapCreateRequestSmtpSecurity;
  set_as_default?: boolean;
  signature_id?: string | null;
}
